package com.shadowings.gero.util

fun encodeUriComponent(s: String): String {
    val allowed = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_.!~*'()"
    val hexChars = "0123456789ABCDEF"
    val sb = StringBuilder()
    for (char in s) {
        if (char in allowed) {
            sb.append(char)
        } else {
            val bytes = char.toString().encodeToByteArray()
            for (b in bytes) {
                val value = b.toInt() and 0xFF
                sb.append('%')
                sb.append(hexChars[value ushr 4])
                sb.append(hexChars[value and 0x0F])
            }
        }
    }
    return sb.toString()
}

fun getRateAppUrl(): String {
    val platformName = com.shadowings.gero.getPlatform().name
    return if (platformName.contains("iOS", ignoreCase = true)) {
        "https://apps.apple.com/app/id6741496355"
    } else {
        "https://play.google.com/store/apps/details?id=com.shadowings.gero"
    }
}
